import { readCamposPersonalizados } from "common/utils/mappers"
import { TIPO_ARTICULOS_OPTIONS } from "../constants/constants"

const mapArticulosObjectToExcel = (
  articulos: $TSMigrationFixMe,
  t: $TSMigrationFixMe
) =>
  articulos.map((articulo: $TSMigrationFixMe) => {
    const { camposPersonalizados } = articulo
    const mappedCustomFields = readCamposPersonalizados(camposPersonalizados)

    delete articulo.camposPersonalizados
    delete articulo.id
    delete articulo.categorias
    delete articulo.thumbnailBase64

    return Object.assign(
      articulo,
      { tipoArticulo: TIPO_ARTICULOS_OPTIONS(t)[articulo.tipoArticulo].label },
      ...mappedCustomFields
    )
  })

export default mapArticulosObjectToExcel
